import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionRole, CommonBasicData } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { Country } from 'src/app/public/common/models/country.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { CarJobCategory, KeepBasicData } from 'src/app/public/keep/constants/keep-basic-data';
import { JobDialogComponent } from 'src/app/public/keep/elements/job-dialog/job-dialog.component';
import { DealerStatus } from '../../constants/dealer-basic-data';
import { Dealer } from '../../models/dealer.model';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { MatExpansionModule } from '@angular/material/expansion';
import { JobsComponent } from 'src/app/public/keep/elements/jobs/jobs.component';

@Component({
    selector: 'app-dealers',
    templateUrl: './dealers.component.html',
    styleUrls: ['./dealers.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, AsyncPipe, CdkOverlayOrigin, CdkConnectedOverlay, RouterModule, MatExpansionModule, JobsComponent]
})
export class DealersComponent {

  @Input() dealers: Dealer [] = [];
  @Input() objectSource: ObjectSource = ObjectSource.DEALER
  @Input() fetchingResults: boolean = false;
  @Input() newDealerCount: number = 0;

  DealerStatus = DealerStatus;
  TransactionRole = TransactionRole

  serviceTypes = CommonBasicData.serviceTypes; 

  CarJobCategory = CarJobCategory

  showDetails: boolean = false;

  //newContractProviderId = "";
  //newContractCount = 0;


  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

    }

  ngOnInit(): void {

    
  }

  updateDealerStatus(dealerId: string, status: DealerStatus){
    this.store.dispatch(DealerActions.dealerStatusUpdateSubmit({ dealerId: dealerId, status: status }));
  }

  toggleFavoriteProvider(dealerId: string ){
    this.store.dispatch(DealerActions.toggleFavoriteProviderSubmit({ providerId: dealerId, makeFav:  ! this.isFavoriteProvider(dealerId) }));
  }

  isFavoriteProvider(dealerId: string): boolean{
    return false;
  }

  goToDealerPublicPage(dealerId: string): any{

    this.router.navigate(
      ['/provider-public'],
      { queryParams: { id: dealerId } }
    );
  }

  openNewContractDialog(providerId: string): void{

    console.log(providerId)

    //this.newContractProviderId = providerId;
    //this.newContractCount++;

  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  getCountryByCode(code: string): Country{
    return GeneralBasicData.getCountryByCode(code)!;
  }

  getRatingsTotalCount(i: number): number{
    return AppFunctions.getArraySum(this.dealers[i].ratingsSummary.counts)
  }

  getServiceTypeTitle(code: string): string{
      return CommonBasicData.getServiceTypeTitle(code)!;
  }

  getCategoryTitle(code: string): string{
      return KeepBasicData.getCarJobCategoryTitle(code)!;
  }

  openJobDialog(offerId: string, jobId: string){
    
    const dialogRef = this.dialog.open(JobDialogComponent, {

      data: new ObjectData(this.objectSource, offerId, +jobId, CarBusinessLine.KEEP, "")

    });
  }

}
